import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGoblin: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconGoblin"><Path d="M15.3226 5.74189L19.7966 4.79324C17.3762 3.48585 15.15 2.52703 12.0002 2C9.21147 4.79915 5.95306 9.04762 5.1402 13.0676H1.5C1.5 17.2838 5.7 17.8108 5.7 17.8108C6.225 19.9189 8.85 21.5 12.0002 21.5C15.1503 21.5 17.775 19.9189 18.3 17.8108C18.3 17.8108 22.5 17.2838 22.5 13.0676H18.8601C18.3697 10.6419 16.891 7.58494 15.3226 5.74189Z" stroke="currentColor"/><Path d="M18 11C13 9.99982 11 9.99992 6 11.0002" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconGoblin;
